var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { attrs: { shadow: "hover" } },
        [
          _c("app-divider", {
            staticClass: "margin-bottom",
            attrs: { label: "Observações: ", addMarginTop: false }
          }),
          _c(
            "el-row",
            { staticClass: "margin-left" },
            [
              _c("el-row", { staticClass: "margin-bottom15" }, [
                _c("span", [
                  _vm._v(
                    "- Alienação de imóveis estaduais de acordo com a Lei nº 110/2018;"
                  )
                ])
              ]),
              _c("el-row", { staticClass: "margin-bottom15" }, [
                _c("span", [
                  _vm._v(
                    "- Os valores definidos na Pauta de Valores de Terra Nua para fins de Titulação expressam o custo médio da terra rural obtida pelo Incra;"
                  )
                ])
              ]),
              _c("el-row", { staticClass: "margin-bottom15" }, [
                _c("span", [
                  _vm._v(
                    "- Em áreas até 15 MF mediante aprovação do órgão fundiário oficial do Estado e acima de 15 MF até 2.500 ha mediante aprovação do órgão fundiário oficial do Estado ecom prévia aprovação da Comissão Permanente de Política Agrária da Assembleia Legislativa."
                  )
                ])
              ]),
              _c("el-row", { staticClass: "margin-bottom15" }, [
                _c(
                  "span",
                  [
                    _vm._v("- Fórmula de Cálculo:"),
                    _c("el-row", { staticClass: "margin-left" }, [
                      _c("b", { staticClass: "color" }, [
                        _vm._v("CÁLCULO DO PERCENTUAL DE BÔNUS")
                      ])
                    ]),
                    _c("el-row", { staticClass: "margin-left" }, [
                      _c("span", [
                        _vm._v(
                          "(Coeficiente Angular   x   Área requerida)   +   Coeficiente Linear   =   Percentual a ser aplicado sobre o VTN"
                        )
                      ])
                    ]),
                    _c("el-row", { staticClass: "margin-left" }, [
                      _c("b", { staticClass: "color" }, [
                        _vm._v("CÁLCULO DE VFI")
                      ])
                    ]),
                    _c("el-row", { staticClass: "margin-left" }, [
                      _c("span", [
                        _vm._v(
                          "((Percentual a ser aplicado sobre o VTN   /   100   )   x   Valor mínimo da Pauta de VTN)   x   Área Requerida   =   Valor Final do Imóvel"
                        )
                      ])
                    ])
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-146c1336", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-146c1336","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/components/Observacoes.vue
// module id = null
// module chunks = 